export const destinationsKeys = {
  all: ['destinations'],
  lists: () => [...destinationsKeys.all, 'list'],
  list: (page: number, perPage: number, search?: string) => [
    ...destinationsKeys.lists(),
    { page, perPage, search },
  ],
  details: () => [...destinationsKeys.all, 'detail'],
  detail: (id: number) => [...destinationsKeys.details(), { id }],
} as const;
